import { createSelector } from 'reselect';
import { get, map, flatMap, filter } from 'lodash/fp';

import { getColumns } from '../utils/challengeUtils';
import t from '../utils/translate';

function normalizeChallenges(lineupChallenges, selectionHash) {
  const challenges = flatMap(ch =>
    map(e => ({
      ...e,
      ...ch,
      id: e.id,
      selectionHash
    }))(ch.userEntries || [])
  )(lineupChallenges);

  return [
    {
      key: 'challenges',
      title: t('Your Entries'),
      challenges: filter({ selectionHash })(challenges),
      columns: getColumns({
        editLineUp: true
      }),
      emptyTitle: t('No Available Challenges'),
      emptyMessage: t('There are no other challenges of this type'),
      alwaysShow: true
    }
  ];
}

const editLineUpSelector = createSelector(
  get('myTeams.lineupChallenges'),
  (state, selectionHash) => selectionHash,
  normalizeChallenges
);

export default editLineUpSelector;
